import { equals } from '@execonline-inc/collections';
import { when } from '@execonline-inc/maybe-adapter';
import { observer } from 'mobx-react';
import { FormTemplate } from '../../../../../../../../../../../../../Resource/FormTemplates/Types';
import InviteTimeForm from '../../../../../../../../../../SharedComponents/InviteTimeForm';
import SkipInvitation from '../../../../../../../../../../SharedComponents/SkipInvitation';
import Form from './Form';
import SkipCommunications from './SkipCommunications';
import Submit from './Submit';

export interface Props {
  template: FormTemplate;
  timeZone: string;
  skipCommunications: boolean;
  setTimezone: (timeZone: string) => void;
  submit: () => void;
  back: () => void;
  setSkipCommunications: (skip: boolean) => void;
}

function Body({
  setTimezone,
  timeZone,
  template,
  submit,
  back,
  skipCommunications,
  setSkipCommunications,
}: Props) {
  return (
    <>
      <SkipCommunications
        skipCommunications={skipCommunications}
        setSkipCommunications={setSkipCommunications}
      />
      {when(equals(true), skipCommunications)
        .map(() => <SkipInvitation />)
        .getOrElseValue(
          <InviteTimeForm>
            <Form
              setTimezone={setTimezone}
              timeZone={timeZone}
              template={template}
              submit={submit}
              disabled={skipCommunications}
            />
          </InviteTimeForm>,
        )}
      <Submit submit={submit} back={back} />
    </>
  );
}

export default observer(Body);
